import type { PortalPlan } from './offer';

export interface AnalysisPlan {
  name: string;
  count: number;
}

/**
 * The plan that unlocks the most analyses a period, if it unlocks more than `current`. Real plan data only:
 * the upgrade copy names this plan and its number, never a figure of its own.
 */
export function bestAnalysisPlan(plans: readonly PortalPlan[] | undefined, current = 0): AnalysisPlan | null {
  let best: AnalysisPlan | null = null;
  for (const plan of plans ?? []) {
    const count = plan.analysisLimit ?? 0;
    if (count > (best?.count ?? 0)) best = { name: plan.name, count };
  }
  return best && best.count > current ? best : null;
}
